import { List as MuiList, Paper } from '@mui/material';

import { makeStyles } from '@mui/styles';

import ListItem from '../ListItem';

const useStyles = makeStyles(
  ({ palette, shape }) => ({
    outlined: {
      border: `1px solid ${palette.stroke}`,
      borderRadius: shape.borderRadius * 2,
    },
  }),
  { classNamePrefix: 'List' }
);

function List({ children = null, elevation = 1, ...otherProps }) {
  const classes = useStyles();

  return (
    <Paper
      elevation={elevation}
      variant={elevation === 0 ? 'outlined' : 'elevation'}
      classes={classes}
    >
      <MuiList {...otherProps}>{children}</MuiList>
    </Paper>
  );
}

List.Item = ListItem;

export default List;
